// choreo #53 / F0162 — the SINGLE SOURCE OF TRUTH for the creator-delete
// routine request on the choreography surface. Both consumers MUST build
// their request through this builder and must never re-inline the shape:
//
//   - src/services/api.js `choreographyApi.deleteRoutine` (the deployed
//     app's delete path), and
//   - src/testSupport/testdeployTeardown.js `choreoDeleter` (the TestDeploy
//     suites' teardown registry).
//
// Why this module exists (2026-09-04, opt-in pipeline 8222, jobs
// 185177/185178/185179): choreo MR !209 guards DELETE /routines/:id behind
// the {"confirm": routineId} body (F0162
// CHOREOGRAPHY_DELETE_CONFIRMATION_REQUIRED → HTTP 400 otherwise). api.js
// sent the body; the teardown registry's copy of the request did not, and
// every routine teardown delete in the three *-testdeploy suites answered
// 400 and leaked its routine into the shared TestDeploy organisation. The
// unit suite had mocked the deleter, so nothing caught the drift. One
// builder, imported by both consumers, closes that drift.

/**
 * The exact request both consumers issue for one routine delete.
 *
 * @param {string} routineId the routine to delete (the F0162 confirm value)
 * @returns {{ method: 'DELETE', path: string, body: { confirm: string } }}
 *   `path` is the choreography-surface suffix (the caller prefixes its own
 *   root: `/v1/orgs/:orgId/choreography` in api.js,
 *   `<baseUrl>/api/v1/orgs/:orgId/choreography` in the teardown registry);
 *   `body` is the F0162 confirmation guard, sent as the JSON request body.
 */
export function buildRoutineDeleteRequest(routineId) {
  return {
    method: 'DELETE',
    path: `/routines/${encodeURIComponent(routineId)}`,
    body: { confirm: routineId },
  };
}
